
    import "./standorte.css";
import React, { useState } from "react";
import karte from "../../img/prc_karte.png";
import kontakte from "../../img/mail.png";
import ContactPhoneOutlined from "@material-ui/icons/ContactPhoneOutlined";

export default function Standorte() {
  return (

  
    <div id="wrapper" style={{ height:'89vh'}}>

      <div style={{display: 'flex',
    height: '100%',
    justifyContent: 'center'}}>

      <div style={{width: '70%',  textAlign: 'center', }}>

      <iframe src="https://www.google.com/maps/d/embed?mid=1hRm2dzXlEKaFbW1tLXfZo3cddD6QiDQ7&ehbc=2E312F"  width="100%" height="100%"></iframe>
      
      </div>
      <div style={{marginLeft: '5px', width: '30%', textAlign:"center", background: 'white', opacity: '0.8'}}>

        
             <div className="div1">  <div className="standort_button">
              <div className="standort_button_header">Catering</div>
              <a
                className="a_box"
                href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/Kostenstellen/Kostenstellenlisten_Catering.pdf"
                target="_blank"
              >
                <img className="standort_button_image" src={kontakte}></img>
              </a>
              <p style={{ clear: "both" }} />
            </div></div>
            <div class="div2"><div className="standort_button">
               <div className="standort_button_header">Cleaning</div>
               <a
                className="a_box"
                href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/Kostenstellen/Kostenstellenlisten_GR.pdf"
                target="_blank"
              >
                <img className="standort_button_image" src={kontakte}></img>
              </a>
              <p style={{ clear: "both" }} />
            </div></div>
            <div class="div3">   
             <div className="standort_button">
              <div className="standort_button_header">Tabula</div>
              <a
                className="a_box"
                href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/Kostenstellen/Kostenstellenlisten_tabula.pdf"
                target="_blank"
              >
                <img className="standort_button_image" src={kontakte}></img>
              </a>
              <p style={{ clear: "both" }} />
            </div></div> 
            
            <div class="div4">   
                  <div className="standort_button">
                        <div className="standort_button_header">Adiuvare</div>
                        <a
                          className="a_box"
                          href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/Kostenstellen/Kostenstellenlisten_adiuvare.pdf"

                          target="_blank"
                        >
                          <img className="standort_button_image" src={kontakte}></img>
                        </a>
                        <p style={{ clear: "both" }} />
                    </div>
            </div>

            <div class="div5">   
                  <div className="standort_button">
                            <div className="standort_button_header">LaComida</div>
           <a
            className="a_box"
            href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/Kostenstellen/Kostenstellenlisten_LaComida.pdf"

                          target="_blank"
                        >
                          <img className="standort_button_image" src={kontakte}></img>
                        </a>
                        <p style={{ clear: "both" }} />
                    </div>
            </div>

            <div class="div6">   
                  <div className="standort_button">
                   <div className="standort_button_header">proCommendo</div>
           <a
           className="a_box"
            href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/Kostenstellen/Kostenstellenlisten_proCommendo.pdf"

                          target="_blank"
                        >
                          <img className="standort_button_image" src={kontakte}></img>
                        </a>
                        <p style={{ clear: "both" }} />
                    </div>
            </div>

            <div class="div7">   
                  <div className="standort_button">
                            <div className="standort_button_header">ProCulogis</div>
           <a
             className="a_box"
             href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/Kostenstellen/Kostenstellenlisten_proculogis.pdf"

                          target="_blank"
                        >
                          <img className="standort_button_image" src={kontakte}></img>
                        </a>
                        <p style={{ clear: "both" }} />
                    </div>
            </div>

            </div>
        

          
            

    </div>
    </div>

  );
}

//     <div id="wrapper">
      
//       <div style={{ height: "100%", float: "left" }}>
//         <img
//           src={karte}
//           style={{ height: "100%", padding: "10px", float: "left" }}
//           alt="Karte"
//         />
//       </div>


//         <div className="standort_button">
//           <div className="standort_button_header">LaComida</div>
//           <a
//             className="a_box"
//             href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/Kostenstellen/Kostenstellenlisten_LaComida.pdf"
//             target="_blank"
//           >
//             <img className="standort_button_image" src={kontakte}></img>
//           </a>
//           <p style={{ clear: "both" }} />
//         </div>
//         <div className="standort_button">
//           <div className="standort_button_header">proCommendo</div>
//           <a
//             className="a_box"
//             href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/Kostenstellen/Kostenstellenlisten_proCommendo.pdf"
//             target="_blank"
//           >
//             <img className="standort_button_image" src={kontakte}></img>
//           </a>
//           <p style={{ clear: "both" }} />
//         </div>
//         <div className="standort_button">
//           <div className="standort_button_header">ProCulogis</div>
//           <a
//             className="a_box"
//             href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/Kostenstellen/Kostenstellenlisten_proculogis.pdf"
//             target="_blank"
//           >
//             <img className="standort_button_image" src={kontakte}></img>
//           </a>
//           <p style={{ clear: "both" }} />
//         </div>
//       </div>
//     </div>
//   );
// }
